require('../../modules/es7.object.entries');
module.exports = require('../../modules/_core').Object.entries;



//////////////////
// WEBPACK FOOTER
// ./~/@babel/polyfill/~/core-js/fn/object/entries.js
// module id = 236
// module chunks = 169